import React from "react";
import { ThemeIcon } from "../themes/icons";


const MoreCard = () => {
    return (
        <div className="store-card-more">
            <div className="store-card-more-icon">
                <ThemeIcon />
            </div>
            <div className="store-card-more-title">
                More Themes Coming Soon
            </div>
            <div className="store-card-more-description">
                We're always working on new themes for your business, check this page once in a while or wait for an announcement.
            </div>
        </div>
    );
};

export default MoreCard;
